<template>
  <v-container>
    <v-layout>
      <v-flex>
        <div class="add-video-wrap">
          <form action="#" class="add-video-form">
            <input type="file" id="file" ref="file" @change="uploadFile">
            <div class="add-video-info">
              <v-icon color="purple" size="90">cloud_upload</v-icon>
              <p>Drag and drop to upload</p>
              <span class="label-wrap">
                or
                <label for="file">browse</label> to choose a file
              </span>
            </div>
          </form>
          <div class="text-xs-center">
            <v-btn dark color="purple" @click="$router.go(-1)">cancel</v-btn>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

export default {
  name: "addVideo",
  data: () => ({}),
  methods: {
    uploadFile(event) {
      let fileData = event.target.files[0];
      this.$store.dispatch("addVideo", fileData);
      console.log(this.$store.state);
      this.$router.push("/edit-video");
    }
  }
};
</script>
<style scoped lang="scss">
.add-video-wrap {
  background-color: #fff;
  height: 100%;
  height: 500px;
  border-radius: 3px;

  .add-video-form {
    position: relative;

    .add-video-info {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: 700;
      text-align: center;

      .v-icon {
        opacity: 0.1;
      }

      p {
        font-size: 21px;
      }

      .label-wrap {
        font-size: 16px;
        color: #767676;

        label {
          color: #800057;
          cursor: pointer;
        }
      }
    }

    input[type="file"] {
      height: 350px;
      width: 100%;
      opacity: 0;
    }
  }
}
</style>